import React from 'react';

import { CarActionsCheck } from 'icons/symbol';
import {
  advertisingMegaphone,
  buy,
  checkCircle,
  deal,
  headphonesCustomerSupport,
  legalScale,
  timeClockCircle,
  sale,
  faceId,
  bank,
} from 'icons/default';

import { BLIPP_FEE_PERCENT } from './globalConstants';
// import { InfoSellUsedCar } from 'components/views/SellUsedCar/components/InfoSellUsedCar';

export const colorBoxBuy = {
  title: 'Samma billån som hos bilhandlaren',
  text: (
    <p>
      Vi hjälper dig med allt från kontroll av bilen till billån, försäkring, garanti, betalning,
      överlämning och finansiering för bara {BLIPP_FEE_PERCENT} % av det slutgiltiga priset på
      bilen. Och du betalar inget förrän köpet är klart.
    </p>
  ),
  list: [
    {
      item: <>Riktigt billån eller banköverföring</>,
      symbol: deal,
    },
    {
      item: <>Omfattande historisk kontroll</>,
      symbol: CarActionsCheck,
    },
    {
      item: <>Experthjälp för säker transaktion och ägarbyte</>,
      symbol: headphonesCustomerSupport,
    },

    {
      item: <>Legitimerade säljare med BankID</>,
      symbol: faceId,
    },
    {
      item: <>Lösen av befintliga lån</>,
      symbol: bank,
    },
  ],
  buttons: [
    {
      text: 'Räkna på månadskostnad',
      href: '#loan',
    },
  ],
};

export const colorBoxSell = {
  title: 'Få upp till 20% mer med hjälp av Blipp',
  text: (
    <p>
      Sälj din bil med experthjälp och gör en trygg och lönsam affär. Låt oss sköta lösen av
      befintliga lån och upprätta digitala kontrakt för en enklare överlämning. Dessutom erbjuder vi
      köparen finansiering, garanti och försäkring när du säljer din bil med Blipp.
    </p>
  ),
  list: [
    {
      item: <>Pengarna direkt på kontot</>,
      symbol: buy,
    },
    {
      item: <>Enbart legitimerade köpare</>,
      symbol: checkCircle,
    },
    {
      item: <>Lösen av befintligt lån</>,
      symbol: bank,
    },
  ],
  buttons: [],
};

export const colorBoxLoan = {
  title: 'Billån med fordonet som säkerhet',
  text: (
    <p>
      Kolla hur mycket du kan låna. Ansök om ett billån från Nordea Finance och se vilken bil du kan
      köpa. Beviljat lån funkar för alla* fordon oavsett om du hittar dem på Blipp, Blocket eller
      hos grannen.
      <br />
      <i className="idiomatic-text">* Max 15 år vid lånetidens slut och godkänd i vår kontroll</i>
    </p>
  ),
  list: [
    {
      item: <>Ansök på 1 min</>,
      symbol: timeClockCircle,
    },
    {
      item: <>Endast 1 kreditupplysning</>,
      symbol: legalScale,
    },
    {
      item: <>Billån med säkerhet</>,
      symbol: advertisingMegaphone,
    },
  ],
  buttons: [
    {
      text: 'Räkna på ditt billån',
      href: '#loan',
    },
    {
      text: 'Företagsleasing',
      href: '/foretag/foretagsleasing',
    },
  ],
};

export const colorBoxPrivateLoan = {
  title: 'Privatlån med samma ränta för alla',
  text: (
    <p>
      Nu kan du ansöka om privatlån när du köper bil med hjälp av Blipp. Med det nya lånet behöver
      du inte lägga någon kontantinsats vid bilköpet, och är ett alternativ när ett vanligt
      fordonslån inte passar. Samma ränta för alla!
    </p>
  ),
  list: [
    {
      item: <>Låna utan kontantinsats</>,
      symbol: buy,
    },
    {
      item: <>Samma ränta för alla</>,
      symbol: deal,
    },
    {
      item: <>Gratis att ansöka</>,
      symbol: advertisingMegaphone,
    },
  ],
  buttons: [
    {
      text: 'För tillfället inte tillgängligt',
      // href: 'https://www.moank.se/partner/63359d9b87fb5b0d2cf43e88/belopp',
    },
  ],
};

export const colorBoxRelease = {
  title: 'Behåll bilen - byt leasing!',
  text: (
    <p>
      Genom att fortsätta leasa din företagsbil med ett nytt avtal har du chansen att se över
      möjligheterna till att minska dina kostnader. Skicka in din ansökan så återkommer vi med ett
      förslag på en ny leasing.
      <br />
      <i className="idiomatic-text">
        Möjligheten att lägga om din nuvarande leasing beror på ditt nuvarande avtal.
      </i>
    </p>
  ),
  list: [
    {
      item: <>Se över dina kostnader</>,
      symbol: buy,
    },
    {
      item: <>Försäkringserbjudande ingår</>,
      symbol: deal,
    },
    {
      item: <>Samla alla leasingavtal på ett ställe</>,
      symbol: sale,
    },
  ],
};

export const colorBoxCompanyLeasing = {
  title: 'Företagsleasing för både det lilla och stora företaget',
  text: (
    <p>
      Med en finansiering via Blipp kan du enkelt köpa en bil som säljs av ett annat företag med en
      ny företagsleasing eller avbetalning som passar dig. Självklart med möjlighet till restvärde.
      Företagsleasing är ofta det mest ekonomiska sättet att finansiera dina företagsbilar.
    </p>
  ),
  list: [
    {
      item: <>Leasa begagnade bilar utan att gå via bilhandlare</>,
      symbol: checkCircle,
    },
    {
      item: <>Opartisk partner med kunskap om marknaden</>,
      symbol: faceId,
    },
    {
      item: <>Erbjud finansiering om du säljer företagsbil</>,
      symbol: sale,
    },
  ],
  buttons: [
    {
      text: 'Anmäl intresse',
      href: 'https://kampanj.blipp.se/foretagsleasing',
    },
    {
      text: 'Lägg om befintlig leasing',
      href: '/foretag/release',
    },
  ],
};

export const colorBuyBlocketCar = {
  title: 'Hittat drömbilen på Blocket? Köp med Blipp!',
  text: (
    <p>
      Ta hjälp av Blipp när du köper en begagnad bil privat. Vi ger dig samma fördelar som
      bilhandlaren ger. Allt från kontroll till billån, garanti och försäkring. Du kan även göra en
      digital bakgrundskontroll av bilen hos Blipp innan du bestämmer dig. När det är dags för affär
      så legitimerar sig både köpare och säljare med BankID hos på Blipp. Tryggt och säkert!
    </p>
  ),
  list: [
    {
      item: <>Möjlighet till billån, garanti och försäkring</>,
      symbol: CarActionsCheck,
    },
    {
      item: <>Personlig rådgivning</>,
      symbol: headphonesCustomerSupport,
    },
    {
      item: <>Trygg och säker affär med BankID</>,
      symbol: deal,
    },
  ],
  buttons: [
    {
      text: 'Bilar på Blocket du kan köpa med Blipp',
      href: 'https://www.blocket.se/bilar/sok?filter=%7B%22key%22%3A%22car.details.vehicleModelYear%22%2C%22range%22%3A%7B%22start%22%3A%222014%22%2C%22end%22%3A%22%22%7D%2C%22type%22%3A%22int%22%7D&filter=%7B%22key%22%3A%22deal.owner.type%22%2C%22values%22%3A%5B%22Privat%22%5D%2C%22type%22%3A%22string%22%7D',
    },
    {
      text: 'Ansök om billån',
      href: '/lanelofte-billan',
    },
  ],
};

export const colorBookTime = {
  title: 'Experthjälp när du köper bil på garageuppfarten',
  text: (
    <p>
      Ta hjälp av Blipp när du köper en begagnad bil privat. Vi ger dig samma fördelar som
      bilhandlaren ger. Allt från kontroll till billån, garanti och försäkring. Du kan även göra en
      digital bakgrundskontroll av bilen hos Blipp innan du bestämmer dig. När det är dags för affär
      så legitimerar sig både köpare och säljare med BankID hos på Blipp. Tryggt och säkert!
    </p>
  ),
  list: [
    {
      item: <>Experthjälp för säker transaktion och ägarbyte</>,
      symbol: headphonesCustomerSupport,
    },
    {
      item: <>Riktigt billån eller banköverföring</>,
      symbol: deal,
    },
    {
      item: <>Omfattande historisk kontroll</>,
      symbol: CarActionsCheck,
    },
    {
      item: <>Legitimerade säljare med BankID</>,
      symbol: faceId,
    },
    {
      item: <>Lösen av befintliga lån</>,
      symbol: bank,
    },
  ],
  buttons: [
    {
      text: 'Bilar på Blocket du kan köpa med Blipp',
      href: 'https://www.blocket.se/bilar/sok?filter=%7B%22key%22%3A%22car.details.vehicleModelYear%22%2C%22range%22%3A%7B%22start%22%3A%222014%22%2C%22end%22%3A%22%22%7D%2C%22type%22%3A%22int%22%7D&filter=%7B%22key%22%3A%22deal.owner.type%22%2C%22values%22%3A%5B%22Privat%22%5D%2C%22type%22%3A%22string%22%7D',
    },
    {
      text: 'Ansök om billån',
      href: '/lanelofte-billan',
    },
  ],
};
